import NoPropertiesOnEventStream from './NoPropertiesOnEventStream';
export default NoPropertiesOnEventStream;
